import React, { Component } from "react";

// Components
import "./style.css";
import EraPreviewBox from "./../EraPreviewBox";
import LoadingBox from "./../LoadingBox";
import MediumSpacer from "./../MediumSpacer";
import { ContentfulClient } from "../../settings";

// The result of a search
class SearchResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            churchImages: {},
        };
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        if(this.props.data) {
            this.getChurchesImages();
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.data !== this.props.data && this.props.data) {
            this.getChurchesImages();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getChurchesImages() {
        const { data } = this.props;
        
        data.forEach(church => {
            ContentfulClient.getEntry(church.historicalBuildingCode)
                .then((response) => {
                    if(!this._isMounted) return;

                    if(response.fields && response.fields.mainimage) {
                        this.setState(prevState => ({
                            churchImages: Object.assign({}, prevState.churchImages, {
                                [church.id]: response.fields.mainimage
                            })
                        }));
                    }
                })
                .catch((error) => {
                    console.error(`Error fetching image for the church ${church.id}: `, error);
                });
        });
    }

    printChurches() {
        if (!this.props.data) return;
        const { data } = this.props;

        const { churchImages } = this.state;

        // TODO: Update image url: refactor that to not use getChurchesImages but get this data from API like for example publicbuildingurl

        return data.map((data, index) => (
            <EraPreviewBox
                key={index}
                title={data.description}
                description={data.additionalText}
                link={`/kirke/${data.id}`}
                image={
                    churchImages[data.id] ? `${churchImages[data.id]}`
                        : "https://placehold.co/400x300"
                }
            />
        ));
    }

    render() {
        const { loading, loadingMore, error } = this.props;
        return (
            <div className="search-result">
                {!loading && (
                    <div className="grid-column-3">{this.printChurches()}</div>
                )}
                {(loading || loadingMore) && <MediumSpacer />}
                {loadingMore && error === "" && (
                    <LoadingBox
                        color="button--purple"
                        size="large"
                        text="Laster kirker"
                    />
                )}
                {loading && error === "" && (
                    <LoadingBox
                        color="button--purple"
                        size="large"
                        text="Laster kirker"
                    />
                )}
                {error !== "" && (
                    <div className="info-box info-box--red">
                        <span>{error}</span>
                    </div>
                )}
            </div>
        );
    }
}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/components/SearchResult/index.js